import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = [ 'subtotal', 'total' ];

    connect() {
        const shippingMethods = document.querySelectorAll('.shipping-method-input');
        shippingMethods.forEach(method => {
            method.addEventListener('click', (event) => {
                const shippingMethodId = event.target.value;
                console.log(`Shipping method selected: ${shippingMethodId}`);

                this.updateOrderSummary(shippingMethodId);
            });
        })
    }

    updateOrderSummary(shippingMethodId) {
        fetch(`/order/calculate_shipping`, {
            method: 'POST',
            body: JSON.stringify({ shipping_method: { id: shippingMethodId } }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                // should we gray out the order summary while loading?
                this.updateSidebar(data);
            })
            .catch(error => {
                console.error('Error updating order summary:', error);
            });
    }

    updateSidebar(data) {
        let shippingFee = document.getElementById('shipping-fee');
        if (shippingFee && data.fee_amount == null) {
            shippingFee.remove();
            this.totalTarget.innerHTML = data.order_total;
        }

        if (data != null && data.fee_amount != null) {
            if (shippingFee == null) {
                let shippingFee = document.createElement('li');
                shippingFee.id = 'shipping-fee';
                shippingFee.innerHTML = `<span class="label">${data.fee_description}:</span> <span class="amount">${data.fee_amount}</span>`;
                this.subtotalTarget.append(shippingFee);
                this.totalTarget.innerHTML = data.order_total;
            }
        }
    }
}
